import React, { Component } from 'react';
import {isEmptyVariable} from '../../../common/Global/commonFunctions';
import moment from "moment";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
class AddTaskMultiSelectDropdown extends Component{
    
    constructor(props) {
        super(props);
    }

    componentDidMount(){
    }
    onDateChange = (date, dateString) => {
        let dateValue = "";
		if (!isEmptyVariable(date)) {
            dateValue = date.format("YYYY-MM-DD");
        }
        this.props.onDateChange(dateValue,this.props.taskId,this.props.templateItemIndex,this.props.fieldItem,this.props.processId,this.props.functionId)
    };

    render(){
        return (
            <DatePicker
                onChange={this.onDateChange}
                format={"DD/MM/YYYY"}
                disabled={(this.props.isNRChecked === "Y" || this.props.isDisabled === "Y")?true:false}
                placeholder={this.props.placeholderValue}
                value={!isEmptyVariable(this.props.fieldValue)?moment(this.props.fieldValue):""} 
            />
    )}
}

export default AddTaskMultiSelectDropdown;
